import type { FC } from 'react';

interface ErrorMessageProps {
  /** The message to show. `null` renders nothing, so a caller can pass its error state straight in. */
  message: string | null;
}

/** An inline failure notice in the prototype's danger tint. */
export const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => {
  if (!message) return null;
  return (
    <p role="alert" className="m-0 bg-danger-soft px-3.5 py-2.5 text-[12.5px] leading-[1.5] text-danger">
      {message}
    </p>
  );
};
